export default __webpack_public_path__ + "static/media/banner.6721ffd8.jpg";